import HeadSection from "../Components/AboutUs/head-section";
import BriefSection from "../Components/AboutUs/brief-section";
import TeamSection from "../Components/AboutUs/team-section";
import Testimonial from "../Components/common-section/testimonial";
import PartnerWithUs from "../Components/AboutUs/partner-with-us";
import EngineerCulture from "../Components/AboutUs/engineer-culture";
import OurProducts from "../Components/common-section/our-product";
import HappyClient from "../Components/common-section/happy-client";
import { lazy, Suspense } from "react";
import MainLayout from "../layout/main-layout";
import CTASection from "../Components/common-section/cta-section";
import MetaTags from "../utils/meta-tags";
const AccrossGlobe = lazy(() => import("../Components/AboutUs/across-globe"));

function AboutUs() {
  return (
    <>
      <MetaTags
        title="About Us | SoftCoding Solutions"
        description="Learn about SoftCoding Solutions – our mission, values, and team behind delivering world-class software services. Trusted IT partner in Ruby on Rails, ReactJS,NodeJS, and more."
        canonical="https://softcodingsolutions.com/about"
        og={{
          title:
            "About Us | SoftCoding Solutions - Experts in Rails, React & Custom Software",
          description:
            "Learn about our team, mission, and values. SoftCoding Solutions is a tech partner focused on quality, speed, and long-term collaboration.",
          url: "https://softcodingsolutions.com/about",
          type: "website",
          site_name: "SoftCoding Solutions",
          image:
            "https://softcodingsolutions.com/static/media/logo%20company.23b84ead7179e68dfe2f.png",
          imageWidth: "1200",
          imageHeight: "630",
        }}
      />
      <MainLayout>
        <HeadSection />
        <BriefSection />
        <EngineerCulture />
        <TeamSection />
        <PartnerWithUs />
        <CTASection />
        <HappyClient />
        <Testimonial />
        {/* <OurProducts /> */}
        <Suspense
          fallback={<div className="text-center py-10">Loading...</div>}
          children={<AccrossGlobe />}
        />
      </MainLayout>
    </>
  );
}

export default AboutUs;
